import { createWebSocketSendActions, createWebSocketReceiveActions } from './createFetchActions';

const virtualFocusGroupSubscribeActions = createWebSocketSendActions('VIRTUAL_FOCUS_GROUP_SUBSCRIBE');
const virtualFocusGroupDataActions = createWebSocketReceiveActions('VIRTUAL_FOCUS_GROUP_DATA');

export { virtualFocusGroupSubscribeActions, virtualFocusGroupDataActions };
